import { Component } from '@angular/core';
import { MenuStoreService } from '@argalis-apps/angular-services';

@Component({
  selector: 'app-argalis-apps-demandes-encadrement-details',
  templateUrl: './demandes-encadrement-details.component.html',
  styleUrls: ['./demandes-encadrement-details.component.scss']
})
export class DemandesEncadrementDetailsComponent {
  constructor(private menuStoreService: MenuStoreService) {}

  getDemandes(demandeList: any[]) {
    this.menuStoreService.emitNotificationNumber(Number(demandeList.length || 0));
  }
}
